module.exports = __webpack_public_path__ + "img/Player-dark.956b568a.svg";